'use es6';

import { List, fromJS } from 'immutable';
import { AGGREGATION } from '../../../constants/configTypes';
import { COUNT } from '../../../constants/metricTypes';
import * as DataTypes from '../../../constants/dataTypes';
import { Config } from '../..';
import { Metric } from '../../metrics';
import { makeFilters } from '../filters';
import { DESC } from '../../../constants/sortOrder';
import { buildDrilldownReport } from '../report';
const getKnownIdColumn = dataType => {
  return {
    [DataTypes.EMAIL]: 'id'
  }[dataType];
};
const getTopLevelDrilldown = (report, keys, options) => {
  const dataType = report.getIn(['config', 'dataType']);
  const metric = keys.get(report.getIn(['config', 'dimensions']).count());
  return makeFilters(report.get('config'), keys, options).then(filters => Config({
    configType: AGGREGATION,
    limit: 5,
    dataType,
    dimensions: List([getKnownIdColumn(dataType)]),
    sort: fromJS([{
      property: metric,
      order: DESC
    }]),
    metrics: List([Metric({
      property: metric,
      metricTypes: [COUNT]
    })]),
    filters
  })).then(config => buildDrilldownReport(report, config, options));
};
export default {
  isSupported: report => {
    const dataType = report.getIn(['config', 'dataType']);
    const dimensions = report.getIn(['config', 'dimensions']) || List();
    const knownId = getKnownIdColumn(dataType);
    return knownId && !dimensions.equals(List([knownId]));
  },
  generate: getTopLevelDrilldown
};